export enum DeafultOptions {
  LEARN_MORE_ID = '20012ff0-7dd1-429b-ac7a-bac3e5b5a80b',
  SITE_UPGRADE = 'SITE_UPGRADE',
}
